import { Trascodifica } from ".";

export class DocumentoRichiestaMutuo {

    id: number;
    nomeFile: string;
    idRichiestaMutuo: number;
    idRichiestaMutuoRichiedente: number;
    idTipologiaDocumento: number;
    tipologiaDocumento: Trascodifica;

}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/models/documento-richiesta-mutuo.ts